import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';


import {
  ParametrosSolitudServiciosEntity,
  DatosGeneralesEntity,
  ServicioSolitudServiciosService,
  TipoReporte,
  OrdenMedicaEntity,
  ReporteOrdenMedicasFiltro
} from 'src/app/services/servicio-solicitud-servicios.service';
import { ImagesService } from 'src/app/services/utils/images.service';
import { ServicioEntidadService, EntidadEmpresarialEntity } from 'src/app/services/servicio-entidad.service';

@Component({
  selector: 'app-reporte-orden-medica',
  templateUrl: './reporte-orden-medica.component.html',
  styleUrls: ['./reporte-orden-medica.component.css']
})
export class ReporteOrdenMedicaComponent implements OnInit {
  filtros: ReporteOrdenMedicasFiltro;
  parametros: ParametrosSolitudServiciosEntity = {} as ParametrosSolitudServiciosEntity;
  entidadEmpresarial: EntidadEmpresarialEntity;
  datosGenerales: DatosGeneralesEntity;
  isHistoria: boolean = true;
  now = new Date();

  mensajeLoading: string = 'Cargando...';
  mensajeError: string;
  logo: string;
  ordenesAgrupadas: OrdenMedicaEntity[][] = [[]];

  constructor(private activatedRoute: ActivatedRoute,
    private servicioImagenes: ImagesService,
    private servicioEntidad: ServicioEntidadService,
    private servicioSolicitudServ: ServicioSolitudServiciosService
  ) {
    this.activatedRoute.url.subscribe(segment => {
      if (segment[0].path === 'reporte-orden-medicas') {
        this.isHistoria = true;
      } else {
        this.isHistoria = false;
      }
      this.activatedRoute.params.subscribe(params => {
        this.parametros.codigo = params['codigoBaseDatos'];
        this.parametros.uncoSede = Number(params['uncoSede']);
        this.parametros.uncoLogin = Number(params['uncoLogin']);
        this.parametros.unco = Number(this.isHistoria ? params['uncoHistoria'] :
          params['uncoEvolucion']);
      });
    });
  }

  ngOnInit() {
  }

  onFiltrosCompletados(filtros: ReporteOrdenMedicasFiltro) {
    this.filtros = filtros;
    this.getLogo();
  }

  async getLogo() {
    try {
      this.logo = '';
      this.mensajeLoading = 'Cargando información del logo entidad ...';
      const response = await this.servicioImagenes.getLogo(this.parametros.codigo);
      response.subscribe((data: any) => {
        this.logo = data.source;
        this.getEntidadEmpresarial();
      }, (err: HttpErrorResponse) => {
        console.error('Error ReporteOrdenMedicaComponent.getLogo()', err);
        this.onError('Error al obtener información del logo entidad, verifique su conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
      });
    } catch (e) {
      console.error('Catch ReporteOrdenMedicaComponent.getLogo()', e);
      this.onError('Error grave al obtener información del logo entidad, intente de nuevo o reporte caso al administrador.');
    }
  }

  async getEntidadEmpresarial() {
    try {
      this.mensajeLoading = 'Cargando información entidad ...';
      const response = await this.servicioEntidad.getEntidadEmpresarial(this.parametros.codigo, this.parametros.uncoSede);
      response.subscribe((data: EntidadEmpresarialEntity[]) => {
        if (data && data.length > 0) {
          this.entidadEmpresarial = data[0];
          this.getDatosGenerales();
        } else {
          this.onError('No se pudo cargar la información de la entidad empresarial. Por favor verifique los filtros.');
        }
      }, (err: HttpErrorResponse) => {
        console.error('Error ReporteOrdenMedicaComponent.getEntidadEmpresarial()', err);
        this.onError('Error al obtener información de la entidad empresarial, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
      });
    } catch (e) {
      console.error('Catch ReporteOrdenMedicaComponent.getEntidadEmpresarial()', e);
      this.onError('Error grave al obtener información de la entidad empresarial, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
    }
  }

  async getDatosGenerales() {
    try {
      this.mensajeLoading = 'Cargando información del afiliado...';
      let response;
      if (this.isHistoria) {
        response = await this.servicioSolicitudServ.getDatosGenerales(this.parametros);
      } else {
        response = await this.servicioSolicitudServ.getDatosGeneralesEvolucion(this.parametros);
      }
      response.subscribe((data: any) => {
        // const result = data['#result-set-1'];
        const result = data['data'];
        if (result.length > 0) {
          this.datosGenerales = this.servicioSolicitudServ.getDatosGeneralesEntity(result);
          this.getOrdenes();
        } else {
          this.onError('No se pudo cargar la información del paciente.');
        }
      }, (err: HttpErrorResponse) => {
        console.error('Error ReporteOrdenMedicaComponent.getDatosGenerales()', err);
        this.onError('Error al obtener información del paciente, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
      });
    } catch (e) {
      console.error('Catch ReporteOrdenMedicaComponent.getDatosGenerales()', e);
      this.onError('Error al obtener información del paciente, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
    }
  }

  async getOrdenes() {
    try {
      this.mensajeLoading = 'Cargando información de ordenes medicas ...';
      let response;
      if (this.isHistoria) {
        if (this.filtros.tipoReporte === TipoReporte.SOLO_HISTORIA) {
          response = await this.servicioSolicitudServ.getOrdenesMedicasHistoria(this.parametros,
            this.filtros.procedimientos);
        } else {
          response = await this.servicioSolicitudServ.getOrdenesMedicas(this.parametros,
            this.filtros.procedimientos);
        }
      } else {
        response = await this.servicioSolicitudServ.getOrdenesMedicasEvolucion(this.parametros,
          this.filtros.procedimientos);
      }
      response.subscribe((data: OrdenMedicaEntity[]) => {
        if (data.length > 0) {
          const { impresionServicios, discriminarServicios, discriminarNoPos } = this.filtros;
          this.ordenesAgrupadas = data.reduce((prev, current) => {
            for (let index = 0; index < prev.length; index++) {
              const procedimiento = prev[index][0]['procedimiento'];
              const lineaProd = prev[index][0]['lineaProducto'];
              if (impresionServicios) {
                if (procedimiento['codigoProcedimiento'] === current['procedimiento']['codigoProcedimiento']) {
                  prev[index].push(current);
                  return prev;
                }
              } else if (discriminarServicios && discriminarNoPos) {
                if (lineaProd['unco'] === current['lineaProducto']['unco'] &&
                  procedimiento['tipoServicioPos'] === current['procedimiento']['tipoServicioPos']) {
                  prev[index].push(current);
                  return prev;
                }
              } else if (discriminarServicios) {
                if (lineaProd['unco'] === current['lineaProducto']['unco']) {
                  prev[index].push(current);
                  return prev;
                }
              } else if (discriminarNoPos) {
                if (procedimiento['tipoServicioPos'] === current['procedimiento']['tipoServicioPos']) {
                  prev[index].push(current);
                  return prev;
                }
              } else {
                prev[0].push(current);
                return prev;
              }
            }
            prev.push([current]);
            return prev;
          }, []);

          this.mensajeLoading = null;
          this.mensajeError = null;
        } else {
          this.onError('No existen registros disponibles, por favor verifique que se haya diligenciado el diagnostico principal.');
        }
      }, (err: HttpErrorResponse) => {
        console.error('Error ReporteOrdenMedicaComponent.getOrdenes()', err);
        this.onError('Error al obtener información las ordenes medicas, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
      });
    } catch (e) {
      console.error('Catch ReporteOrdenMedicaComponent.getOrdenes()', e);
      this.onError('Error grave al obtener información las ordenes medicas, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.');
    }
  }

  getDescripcionDiagnostico(key: 'diagnostico' | 'diagnosticoRel1' | 'diagnosticoRel2') {
    let descripcion = '--';
    if (this.ordenesAgrupadas[0].length > 0) {
      const orden = this.ordenesAgrupadas[0][0];
      const codigo = orden[key].codigoDiagnostico;
      if (orden[key].activaDescripcion) {
        descripcion = `(${codigo}) ${orden[key].descripcion}`;
      } else {
        if (codigo !== null && codigo.trim().length > 0) {
          descripcion = `(${codigo})`
        }
      }
    }
    return descripcion;
  }

  getPrefijo() {
    return this.isHistoria ? 'HC' : 'EV';
  }

  onErrorGenerado(mensajeError: string) {
    this.mensajeError = mensajeError;
  }

  onError(msj) {
    this.entidadEmpresarial = null;
    this.mensajeLoading = null;
    this.mensajeError = msj;
  }

  isLoading(): boolean {
    return this.mensajeLoading && this.mensajeLoading.length > 0
      && !this.isError();
  }

  isError(): boolean {
    return this.mensajeError && this.mensajeError.length > 0;
  }

  isReady(): boolean {
    return !this.isLoading() && !this.isError();
  }

}
